import { render, staticRenderFns } from "./paciente-new.vue?vue&type=template&id=3a270d67&"
import script from "./paciente-new.vue?vue&type=script&lang=js&"
export * from "./paciente-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports